<template>
    <div v-if="showAuthorInfo" class="author-info">
        <PrismicImage v-if="isFilled.image(document?.data?.authorImage)" :field="document?.data?.authorImage" height="48" width="48" />
        <div>
            <p v-if="document?.data?.authorName" class="author-name">{{ document?.data?.authorName }}</p>
            <p v-if="document?.data?.authorJob" class="author-job">{{ document?.data?.authorJob }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {inject, ref} from 'vue';
    import {isFilled} from '@prismicio/helpers';
    import {PrismicImage} from '@prismicio/vue';
    import {PRISMIC_DOCUMENT} from '~/app/keys';

    const document = inject(PRISMIC_DOCUMENT);

    const showAuthorInfo = ref(['article', 'successStory'].includes(document?.value?.type as string));
</script>

<style lang="scss">
    .author-info {
        display: flex;
        align-items: center;
        gap: var(--joy-core-spacing-3);
        img {
            height: 48px;
            width: 48px;
            border-radius: 48px;
            object-fit: cover;
        }
        .author-name {
            font-family: var(--joy-font-family-title);
            font-size: var(--joy-font-size-primary-600);
        }
        .author-job {
            color: var(--joy-color-neutral-40);
            font-size: var(--joy-font-size-primary-300);
        }
    }
</style>
